export default "__VITE_ASSET__C_sV9pZn__"